import React from 'react';
import TableChartIcon from '@mui/icons-material/TableChart';
import {
    MenuButton,
    MenuButtonBold,
    MenuButtonBulletedList,
    MenuButtonHorizontalRule,
    MenuButtonItalic,
    MenuButtonOrderedList,
    MenuButtonStrikethrough,
    MenuButtonSubscript,
    MenuButtonSuperscript,
    MenuButtonUnderline,
    MenuControlsContainer,
    MenuDivider,
    MenuSelectHeading,
    MenuSelectTextAlign,
    useRichTextEditorContext,
} from 'mui-tiptap';
import { ts } from 'src/utils/translate';

const INSERT_TABLE_OPTIONS = { rows: 3, cols: 3, withHeaderRow: false };

export const GeneralInfoMenuControls = () => {
    const editor = useRichTextEditorContext();

    const insertTable = () => {
        editor?.chain().focus().insertTable(INSERT_TABLE_OPTIONS).run();
    };

    return (
        <MenuControlsContainer>
            <MenuSelectHeading />
            <MenuDivider />
            <MenuButtonBold />
            <MenuButtonItalic />
            <MenuButtonUnderline />
            <MenuButtonStrikethrough />
            <MenuButtonSubscript />
            <MenuButtonSuperscript />
            <MenuDivider />
            <MenuButtonBulletedList />
            <MenuButtonOrderedList />
            <MenuSelectTextAlign />
            <MenuDivider />
            <MenuButton
                tooltipLabel={ts('project_settings_quote_insert_table', 'Insert table')}
                IconComponent={TableChartIcon}
                disabled={!editor?.isEditable || !editor.can().insertTable(INSERT_TABLE_OPTIONS)}
                onClick={insertTable}
            />
            <MenuButtonHorizontalRule />
        </MenuControlsContainer>
    );
};
